import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Paper, Typography, Button, Box, Alert, CircularProgress } from '@mui/material';
import { activateAccount } from '../../services/AuthService';

/**
 * Página para ativação de conta com token recebido por email
 */
export default function ActivateAccountPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [_token, setToken] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  // Extrair o token da URL
  useEffect(() => {
    const handleActivation = async (activationToken) => {
      setLoading(true);
      setError('');

      try {
        await activateAccount(activationToken);
        setSuccess(true);

        // Redirecionar para login após 3 segundos
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 3000);
      } catch (err) {
        console.error('Erro ao ativar conta:', err);

        if (err.response) {
          if (err.response.status === 400 && err.response.data && err.response.data.detail) {
            setError(err.response.data.detail);
          } else {
            setError(`Erro ${err.response.status}: Falha ao ativar a conta`);
          }
        } else if (err.request) {
          setError('Não foi possível conectar ao servidor. Verifique sua conexão.');
        } else {
          setError('Erro ao processar solicitação: ' + (err.message || 'Erro desconhecido'));
        }
      } finally {
        setLoading(false);
      }
    };

    const query = new URLSearchParams(location.search);
    const tokenFromQuery = query.get('token');

    if (tokenFromQuery) {
      setToken(tokenFromQuery);
      handleActivation(tokenFromQuery);
    } else {
      setError('Token de ativação não encontrado na URL');
    }
  }, [location, navigate]);

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f5f5f5',
      }}
    >
      <Paper elevation={3} sx={{ p: 4, minWidth: 320, maxWidth: 500 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Ativação da Conta
        </Typography>

        {loading ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 3 }}>
            <CircularProgress sx={{ mb: 2 }} />
            <Typography>Validando seu email...</Typography>
          </Box>
        ) : success ? (
          <>
            <Alert severity="success" sx={{ mb: 2 }}>
              Sua conta foi ativada com sucesso!
            </Alert>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Você será redirecionado para a página de login em alguns segundos.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => navigate('/login')}
            >
              Ir para o Login
            </Button>
          </>
        ) : (
          <>
            {error && (
              <>
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  O link de ativação pode ser inválido ou já ter expirado. Entre em contato com o
                  suporte ou tente se registrar novamente.
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => navigate('/register')}
                >
                  Ir para Registro
                </Button>
              </>
            )}
          </>
        )}
      </Paper>
    </Box>
  );
}
